import { createContext } from "react";
import type { CutId, CutOption } from "../data/cuts";
import type { PackId, PackSize } from "../data/packs";
import type { SeafoodItem } from "../data/seafood";

export interface ResolvedCartLine {
  item: SeafoodItem;
  pack: PackSize;
  /** The cut chosen for this catch. */
  cut: CutOption;
  /** Number of packs. */
  qty: number;
  /** Price of ONE pack including the cut's prep fee. */
  unitPrice: number;
  lineTotal: number;
}

export interface CartContextValue {
  lines: ResolvedCartLine[];
  /** Total number of packs in the cart. */
  itemCount: number;
  /** Total weight in kg. */
  totalKg: number;
  subtotal: number;
  /** True when the catch is in the cart in any pack size. */
  isInCart: (id: string) => boolean;
  /** Packs of this catch in this size (0 when absent). */
  qtyOf: (id: string, pack: PackId) => number;
  /**
   * Set the number of packs of a catch in one size; 0 (or less) removes that line, an absent line is added. `cut` sets the
   * catch's cut (omit to keep the current one, or the default for a new line).
   */
  setQty: (id: string, pack: PackId, qty: number, cut?: CutId) => void;
  /** The cut currently chosen for a catch in the cart, or undefined when it isn't in the cart. */
  cutIdOf: (id: string) => string | undefined;
  removeItem: (id: string, pack: PackId) => void;
  clear: () => void;
}

export const CartContext = createContext<CartContextValue | null>(null);
